/* eslint-disable no-unused-vars */
import { Web3NFTService } from '../../services/Web3NFTService';

export default {
  name: 'InternalOnly',
  data() {
    return {
      balance: 0,
      minted: false,
      formInput: {
        account: '',
        amount: 1,
        tokenId: '',
        price: 0,
      },
      ownerAddress: '',
      onis: null,
      /**
       * @type { Web3NFTService }
       */
      web3Config: new Web3NFTService(),
      account: null,
    };
  },
  methods: {
    accountsWatch() {
      if (this.web3Config.provider) {
        this.web3Config.provider.on('accountsChanged', (accounts) => {
          this.account = accounts[0];
          this.web3Config.account = accounts[0];
          this.getBalance();
        });
      }
    },
    getWeb3Config() {
      this.web3Config
        .getConfig()
        .then((config) => {
          this.account = config.accounts[0];
          this.accountsWatch();
          this.getBalance();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    async setMax(number) {
      this.web3Config.setMax(number);
    },
    async _baseURI() {
      const baseTokenURI = await this.web3Config.web3.methods.baseTokenURI().call();
    },
    async mint() {
      await this.web3Config.mint(
        this.formInput.amount,
        () => {
          this.minted = true;
          this.getBalance().then(() => {
            this.tokenOfOwnerByIndex();
          });
        },
        (error) => {
          console.error(error);
        }
      );
    },
    getBalance() {
      return new Promise((resolve, reject) => {
        this.web3Config
          .getBalance()
          .then((balance) => {
            this.balance = balance;
            resolve();
          })
          .catch((error) => {
            console.error(error);
            reject();
          });
      });
    },
    async unpause() {
      this.web3Config.unpause();
    },
    async pause() {
      this.web3Config.pause();
    },
    async tokenOfOwnerByIndex() {
      this.web3Config.checkOwnerTokensContractManagement(this.formInput.account).then((res) => {
        this.onis = res;
      });
    },
    async ownerOf() {
      this.web3Config.ownerOf(this.formInput.tokenId).then((res) => {
        this.ownerAddress = res;
      });
    },
    async setMaxOnis() {
      this.web3Config.setMAX_ELEMENTS(this.formInput.maxOnis);
    },
    async setPRICE() {
      console.log(this.formInput.price);
      this.web3Config.setPRICE(this.formInput.price);
    },
  },
  mounted() {
    this.getWeb3Config();
  },
};
